import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { motion } from "framer-motion";

export default function Sejarah() {
  const [deskripsi, setDeskripsi] = useState("");
  const [fotoList, setFotoList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snap = await getDoc(doc(db, "profilSekolah", "sejarah"));
        if (snap.exists()) {
          const data = snap.data();
          // pastikan foto berbentuk objek
          const formattedFoto =
            Array.isArray(data.foto) &&
            data.foto.map((f) => (typeof f === "string" ? { url: f, judul: "", teks: "" } : f));

          setDeskripsi(data.deskripsi || "");
          setFotoList(formattedFoto || []);
        }
      } catch (err) {
        console.error("Error mengambil data sejarah:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <div style={{ background: "linear-gradient(135deg, #e8f0fe 0%, #f8f9fa 100%)", minHeight: "100vh", paddingTop: 60, paddingBottom: 60 }}>
      <div className="container">
        <motion.div initial={{ opacity: 0, y: -30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-center mb-5">
          <h1 className="fw-bold text-primary mb-3">Sejarah Sekolah</h1>
          <p className="text-muted fs-5">Menelusuri perjalanan panjang sekolah kami dari awal berdiri hingga kini ✨</p>
          <div style={{ width: 80, height: 4, backgroundColor: "#0d6efd", margin: "16px auto", borderRadius: 8 }}></div>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} className="mb-5">
          <div className="bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary">
            <p style={{ fontSize: "1.15rem", lineHeight: 1.9, textAlign: "justify" }}>
              {deskripsi || "Belum ada deskripsi sejarah sekolah."}
            </p>
          </div>
        </motion.div>

        <div className="position-relative">
          <div className="position-absolute top-0 start-50 translate-middle-x" style={{ width: 5, height: "100%", background: "linear-gradient(180deg, #0d6efd, #66b2ff)", borderRadius: 8, opacity: 0.3 }}></div>

          <div className="timeline mt-5">
            {fotoList.length > 0 ? (
              fotoList.map((foto, index) => (
                <motion.div key={index} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}
                  className={`d-flex flex-column flex-md-row align-items-center mb-5 position-relative ${index % 2 === 0 ? "flex-md-row" : "flex-md-row-reverse"}`}>
                  <div className="position-absolute start-50 translate-middle rounded-circle bg-primary" style={{ width: 16, height: 16, top: "40%", boxShadow: "0 0 10px rgba(13,110,253,0.5)" }}></div>

                  <motion.div whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 200 }} className="col-md-6 mb-3 mb-md-0 text-center">
                    <img src={foto.url} alt={foto.judul || `Foto sejarah ${index + 1}`} style={{ width: "100%", maxWidth: 500, height: 350, objectFit: "cover", borderRadius: 20, boxShadow: "0 8px 20px rgba(0,0,0,0.2)" }} />
                  </motion.div>

                  <div className="col-md-6 px-4">
                    <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.2 }} className="p-4 rounded-4 shadow-sm bg-white border-start border-4 border-primary">
                      <h5 className="fw-semibold text-primary mb-2">{foto.judul || `Momen Sejarah ${index + 1}`}</h5>
                      <p className="text-muted mb-0">{foto.teks || "Potret perjalanan penting dalam sejarah sekolah kami yang menginspirasi generasi berikutnya."}</p>
                    </motion.div>
                  </div>
                </motion.div>
              ))
            ) : (
              <p className="text-muted text-center mt-5">Belum ada foto sejarah yang ditambahkan.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
